<template>
	<div class="MyComplaintDetails">
		<div class="MyComplaintDetails_my">
			<div class="MyComplaintDetails_my_top">
				<div class="MyComplaintDetails_my_left">
					<img :src="complaintmessage.avatarurl" />
				</div>
				<div class="MyComplaintDetails_my_right">
					<div class="MyComplaintDetails_my_right_name">{{complaintmessage.name}}</div>
					<div class="MyComplaintDetails_my_right_time">{{complaintmessage.createtime}}</div>
				</div>
			</div>
			<div class="MyComplaintDetails_my_title">{{complaintmessage.title}}</div>
			<div class="MyComplaintDetails_my_content">{{complaintmessage.content}}</div>
		</div>
		<div class="MyComplaintDetails_Customer" v-if="complaintmessage.status=='2'">
			<div class="MyComplaintDetails_Customer_top">
				<div class="MyComplaintDetails_Customer_left">
					<img :src="complaintmessage.reply_userobj.avatarurl" />
				</div>
				<div class="MyComplaintDetails_Customer_right">
					<div class="MyComplaintDetails_Customer_right_name">{{complaintmessage.reply_userobj.name}}</div>
					<div class="MyComplaintDetails_Customer_right_time">{{complaintmessage.process_time}}</div>
				</div>
			</div>
			<div class="MyComplaintDetails_Customer_bottom"><span>{{complaintmessage.reply_userobj.name}}：</span>{{complaintmessage.process_resul}}</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'MyComplaintDetails',
		data() {
			return {
				baseUrl: "",
				cmid: "",
				complaintmessage: ""
			}
		},
		methods: {

		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/reception/ajax";
			}
			that.baseUrl = baseUrl;
			that.cmid = sessionStorage.getItem('cmid')
			wclient.view.showLoading();
			wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
			wclient.ajax({
				type: "GET",
				url: that.baseUrl + '?ugi=complaint&action=chackdetails',
				dataType: "json",
				async: true,
				data: {
					cmid: that.cmid
				},
				success: function(data) {
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						that.complaintmessage = data.complaintmessage;
					}
				}
			});
		}
	}
</script>

<style scoped>
	.MyComplaintDetails {
		width: 100%;
		height: 100vh;
		background: white;
		-webkit-overflow-scrolling: touch;
	}
	
	.MyComplaintDetails_my {
		width: 90%;
		margin: 0 auto;
		padding: 10px 5%;
		border-bottom: 4px solid #F5F5F5;
	}
	
	.MyComplaintDetails_my_top {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.MyComplaintDetails_my_left {
		width: 45px;
		height: 45px;
		border-radius: 50%;
		overflow: hidden;
	}
	
	.MyComplaintDetails_my_right {
		margin-left: 10px;
		line-height: 20px;
	}
	
	.MyComplaintDetails_my_right_name {
		font-size: 16px;
		color: #232323;
	}
	
	.MyComplaintDetails_my_right_time {
		font-size: 12px;
		color: #ABABAB;
	}
	
	.MyComplaintDetails_my_title {
		width: 100%;
		margin-top: 10px;
		font-size: 16px;
		color: #232323;
	}
	
	.MyComplaintDetails_my_content {
		width: 100%;
		font-size: 14px;
		color: #767676;
	}
	
	.MyComplaintDetails_Customer {
		width: 90%;
		margin: 0 auto;
		padding: 10px 5%;
	}
	
	.MyComplaintDetails_Customer_top {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.MyComplaintDetails_Customer_left {
		width: 45px;
		height: 45px;
		border-radius: 50%;
		overflow: hidden;
	}
	
	.MyComplaintDetails_Customer_right {
		margin-left: 10px;
		line-height: 20px;
	}
	
	.MyComplaintDetails_Customer_right_name {
		font-size: 16px;
		color: #232323;
	}
	
	.MyComplaintDetails_Customer_right_time {
		font-size: 12px;
		color: #ABABAB;
	}
	
	.MyComplaintDetails_Customer_bottom {
		width: 92%;
		background: rgba(246, 246, 246, 1);
		border-radius: 4px;
		font-size: 14px;
		padding: 8px 4%;
		margin-top: 10px;
	}
	.MyComplaintDetails_Customer_bottom span{
		color: #405FB2;
	}
</style>


// WEBPACK FOOTER //
// src/components/MyComplaintDetails.vue